import { PerformanceMonitor } from "@react-three/drei";
import { Canvas, extend } from "@react-three/fiber";
import { geometry } from "maath";
import { Suspense, useState } from "react";
import * as THREE from "three";
import { Euler } from "three";
import useCheckMobileScreen from "./checkMobileScreen";
import Box from "./Components/Box/Box";
import Cone from "./Components/Cone/Cone";
import Frame from "./Components/Frame/Frame";
import Overlay from "./Components/Overlay/Overlay";
import Rig from "./Components/Rig/rig";
import Sphere from "./Components/Sphere/Sphere";

extend(geometry);
THREE.ColorManagement.enabled = true;

export const App = () => {
  const [dpr, setDpr] = useState(1);
  const mobileScreen = useCheckMobileScreen();

  return (
    <>
      <div style={{ height: "100%", width: "100%", background: "#f0f0f0" }}>
        <Canvas
          frameloop={dpr === 1 ? "always" : "demand"}
          dpr={dpr}
          shadows
          camera={{ fov: mobileScreen ? 100 : 75, position: [0, 0, 20] }}
          eventSource={document.getElementById("root") ?? undefined}
          eventPrefix="client"
        >
          <Suspense fallback={<></>}>
            <PerformanceMonitor
              onIncline={() => setDpr(1)}
              onDecline={() => setDpr(0.5)}
            />
            <color attach="background" args={["#f0f0f0"]} />

            <Frame
              frame_id="01"
              name="Cube"
              author=""
              bg="#ccb38f"
              position={[-1.15, 0, 0]}
              rotation={new Euler(0, 0.5, 0)}
            >
              <Box position={[0, 0.5, -2]} rotation={[0, -0.4, 0]} />
            </Frame>
            <Frame
              frame_id="02"
              name="Sphere"
              author=""
              bg="indianred"
              position={[0, 0, 0]}
              rotation={new Euler(0)}
            >
              <Sphere position={[0, 0.55, -2]} />
            </Frame>
            <Frame
              frame_id="03"
              name="Cone"
              author=""
              bg="#7ea8be"
              position={[1.15, 0, 0]}
              rotation={new Euler(0, -0.5, 0)}
            >
              <Cone position={[0, 0.6, -2]} />
            </Frame>
            <Rig />
          </Suspense>
        </Canvas>
      </div>
      <Overlay />
    </>
  );
};
